import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { State } from 'src/app/interfaces/state';

import { LicenseForm } from './license-form';
import { PrimaryTradeForm } from './primary-trade-form';
import { SubNationalDivisionForm } from './sub-national-division-form';
import { TradeLicenseForm } from './trade-license-form';
import { VendorTradeForm } from './vendor-trade-form';

export class PrimaryTradeLicenseRequirementForm extends FormGroup<{
  id: FormControl<number | undefined>;
  PrimaryTradeId: FormControl<number | undefined>;
  SubNationalDivisionId: FormControl<number | undefined>;
  state: FormControl<State | undefined>;
  isRequired: FormControl<boolean>;
  lookupURL: FormControl<string | null>;
  city: FormControl<string | null>;

  PrimaryTrade?: PrimaryTradeForm;
  SubNationalDivision?: SubNationalDivisionForm;
  Licenses?: FormArray<LicenseForm>;
  VendorTrade?: VendorTradeForm;
  TradeLicenses?: FormArray<TradeLicenseForm>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      PrimaryTradeId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      SubNationalDivisionId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      state: new FormControl<State | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isRequired: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      lookupURL: new FormControl<string | null>(null),
      city: new FormControl<string | null>(null)
    });
  }
}
